import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from 'react';
import { useViewport } from '@sbt-web/hooks';
import { OptimizelySubitoContext } from '@sbt-web/houston-wrapper';
import { AdsGAMPlacement } from '@/client/components/Adv/GPT';
import { LiraContainerIds } from '@/client/components/Adv/Lira/liraContainerIds';

// This toggle handles the placement below the gallery (for desktop)
const DESKTOP_BELOW_GALLERY_PLACEMENT_TOGGLE = 'subito.web.adv.below-gallery';
let alreadyFetched = false;
export const LiraLazySlotBelowGalleryForDesktop = t0 => {
  const $ = _c(10);
  const {
    cssClass
  } = t0;
  const {
    optimizely
  } = useContext(OptimizelySubitoContext);
  const {
    isDesktop
  } = useViewport();
  const [showBannerBelowGallery, setShowBannerBelowGallery] = useState(false);
  let t1;
  let t2;
  if ($[0] !== isDesktop || $[1] !== optimizely) {
    t1 = () => {
      if (isDesktop) {
        optimizely?.onReady().then(() => {
          setShowBannerBelowGallery(optimizely.isFeatureEnabled(DESKTOP_BELOW_GALLERY_PLACEMENT_TOGGLE));
        });
      }
    };
    t2 = [isDesktop, optimizely];
    $[0] = isDesktop;
    $[1] = optimizely;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[4] !== showBannerBelowGallery) {
    t3 = () => {
      if (!alreadyFetched && showBannerBelowGallery) {
        alreadyFetched = true;
        window.liraSDKQueue?.push(_temp);
      }
    };
    t4 = [showBannerBelowGallery];
    $[4] = showBannerBelowGallery;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== cssClass || $[8] !== showBannerBelowGallery) {
    t5 = showBannerBelowGallery ? <AdsGAMPlacement classes={[cssClass]} id={LiraContainerIds.adView.belowGallery} /> : null;
    $[7] = cssClass;
    $[8] = showBannerBelowGallery;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
function _temp() {
  window.liraSdk.fetchLazyLoadAd([LiraContainerIds.adView.belowGallery]);
}